import {
  Control,
  Controller,
  FieldValues,
  Path,
  UseControllerProps,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import {
  IMoneyFieldProps,
  MoneyField,
} from '@/common/components/Fields/MoneyField/MoneyField';
import {
  MoneyUtils,
  TMoney,
  defaultMoney,
} from '@coverflex-tech/hypernova-utils';

export const ControlledMoneyField = <T extends FieldValues>({
  name,
  control,
  minAmount = defaultMoney,
  rules,
  ...restProps
}: IControlledMoneyFieldProps<T>) => {
  const { t } = useTranslation();
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { ref, ...field }, fieldState }) => {
        return (
          <MoneyField
            {...field}
            {...restProps}
            id={name}
            amount={field.value}
            error={
              fieldState.error?.message
                ? t(fieldState.error?.message, {
                    limit: MoneyUtils.moneyToString(minAmount),
                  })
                : ''
            }
          />
        );
      }}
    />
  );
};

interface IControlledMoneyFieldProps<T extends FieldValues>
  extends Omit<IMoneyFieldProps, 'id' | 'onChange'> {
  name: Path<T>;
  control?: Control<T>;
  rules?: UseControllerProps<T>['rules'];
  minAmount?: TMoney;
}
